export default __webpack_public_path__ + "static/media/Coin.9c991652.svg";